import { z } from 'zod';
/**
 * Схемы для внутренней панели «Проверка ПП 1317» — read-only view для
 * ролей ADMIN и AUDITOR, аналог того, что увидит уполномоченный орган.
 *
 * На этапе 10 эти же сервисы будут переиспользованы под `/oversight/v1/` API.
 */
/** Общий фильтр периода (для большинства журналов). */
export const auditPeriodFilterSchema = z.object({
    fromDate: z.string().datetime().optional(),
    toDate: z.string().datetime().optional(),
});
/** Фильтр периода + по клиенту. */
export const auditClientFilterSchema = auditPeriodFilterSchema.extend({
    clientId: z.string().optional(),
});
/** Список клиентов с базовыми атрибутами + тип-specific данные. */
export const auditClientDtoSchema = z.object({
    id: z.string(),
    serviceId: z.string(),
    type: z.enum(['INDIVIDUAL', 'ENTREPRENEUR', 'LEGAL_RU', 'LEGAL_FOREIGN']),
    displayName: z.string(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    oneCExternalId: z.string().nullable(),
    createdAt: z.string().datetime(),
    deregisteredAt: z.string().datetime().nullable(),
    isActive: z.boolean(),
    /** type-specific блок: один из individual / entrepreneur / legalRu / legalForeign. */
    details: z.record(z.unknown()).nullable(),
});
export const auditRegistrationEventDtoSchema = z.object({
    id: z.string(),
    clientId: z.string(),
    clientName: z.string(),
    occurredAt: z.string().datetime(),
    timezone: z.string(),
    clientIp: z.string(),
    clientPort: z.number().nullable(),
    serverIp: z.string(),
    serverPort: z.number(),
    userAgent: z.string().nullable(),
    payload: z.record(z.unknown()),
});
export const auditAuthEventDtoSchema = z.object({
    id: z.string(),
    userId: z.string(),
    userEmail: z.string(),
    occurredAt: z.string().datetime(),
    timezone: z.string(),
    success: z.boolean(),
    clientIp: z.string(),
    clientPort: z.number().nullable(),
    serverIp: z.string(),
    serverPort: z.number(),
    userAgent: z.string().nullable(),
});
export const auditProfileChangeDtoSchema = z.object({
    id: z.string(),
    clientId: z.string(),
    clientName: z.string(),
    occurredAt: z.string().datetime(),
    changedByUserId: z.string(),
    changedByEmail: z.string().nullable(),
    fieldPath: z.string(),
    oldValue: z.unknown(),
    newValue: z.unknown(),
});
export const auditDeregistrationDtoSchema = z.object({
    id: z.string(),
    clientId: z.string(),
    clientName: z.string(),
    occurredAt: z.string().datetime(),
    timezone: z.string(),
    clientIp: z.string(),
    clientPort: z.number().nullable(),
    serverIp: z.string(),
    serverPort: z.number(),
    reason: z.string().nullable(),
});
export const auditLogDtoSchema = z.object({
    id: z.string(),
    occurredAt: z.string().datetime(),
    userId: z.string().nullable(),
    userEmail: z.string().nullable(),
    action: z.string(),
    entityType: z.string(),
    entityId: z.string().nullable(),
    clientIp: z.string().nullable(),
    userAgent: z.string().nullable(),
    payload: z.unknown(),
});
/** Сводные счётчики для главной страницы аудита. */
export const auditSummarySchema = z.object({
    clients: z.number(),
    registrationEvents: z.number(),
    authEvents: z.number(),
    authFailures: z.number(),
    profileChanges: z.number(),
    deregistrations: z.number(),
    orders: z.number(),
    quotes: z.number(),
    contracts: z.number(),
    shipments: z.number(),
    cargoEvents: z.number(),
    geoTrackPoints: z.number(),
    payments: z.number(),
    auditLogs: z.number(),
});
//# sourceMappingURL=audit-view.js.map